import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import Button from '@mui/material/Button'
import FormHelperText from '@mui/material/FormHelperText'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const StyledForm = styled('form')(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'column',
  display: 'flex',
  margin: '1rem',
  borderRadius: '1rem',
  boxShadow: '0 0 1rem 1px rgba(0,0,0,0.1)',
  width: '100%',
  maxWidth: '26rem',
  padding: '3rem 3rem 4rem 3rem',
  [theme.breakpoints.down('sm')]: {
    width: '70%',
    padding: '2rem',
  },
}))

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '2rem',
  fontSize: '2.2rem',
  fontWeight: 'bold',
}))

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: '0.6rem',
  width: '100%',
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  width: '100%',
  background: theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    background: theme.palette.primary.dark,
  },
}))

export const StyledErrorMessage = styled(FormHelperText)(() => ({
  color: 'red',
}))

export const styledLoading = {
  marginLeft: '10px',
  fontSize: 'inherit !important',
}

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
